module.exports = __webpack_public_path__ + "img/tidal.e6b18a75.png";